// client/src/components/marketer/cps/modals/SettleConfirmModal.js
import React from 'react';

function SettleConfirmModal({ open, onClose, onConfirm, settlementInfo }) {
  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="mbm-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1300
      }}
      onClick={handleBackdropClick}
    >
      <div
        className="mb-card mbm"
        style={{ 
          width: '90vw',
          maxWidth: 420,
          margin: 0,
          padding: '32px',
          textAlign: 'center'
        }} 
        onClick={e => e.stopPropagation()}
      >
        {/* 아이콘 */}
        <div style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: 32
        }}>
          💰
        </div>

        {/* 제목 */}
        <h3 className="mbm-title" style={{
          margin: '0 0 12px',
          lineHeight: 1.4
        }}>
          정산을 진행하시겠습니까?
        </h3>

        {/* 설명 */}
        <p style={{
          margin: '0 0 24px',
          fontSize: 14,
          color: 'var(--mb-text-sub)',
          lineHeight: 1.6
        }}>
          입력하신 내용으로 보증금(리워드 총 예산)에서<br/>
          포인트가 차감되고 인플루언서에게 즉시 지급됩니다.
        </p>

        {/* 정산 정보 요약 */}
        {settlementInfo && (
          <div style={{
            padding: '16px',
            background: '#f6f8fb',
            border: '1px solid var(--mb-border-color)',
            borderRadius: 8,
            marginBottom: 20
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 8,
              fontSize: 13,
              color: 'var(--mb-text-sub)'
            }}>
              <span>결산 회차</span>
              <span style={{ fontWeight: 600, color: 'var(--mb-text-title)' }}>
                {settlementInfo.roundNumber}회차
              </span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 8,
              fontSize: 13,
              color: 'var(--mb-text-sub)'
            }}>
              <span>대상 인원</span>
              <span style={{ fontWeight: 600, color: 'var(--mb-text-title)' }}>
                {settlementInfo.targetCount}명
              </span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: 12,
              marginTop: 12,
              borderTop: '1px solid var(--mb-border-color)',
              fontSize: 14
            }}>
              <span style={{ fontWeight: 600, color: 'var(--mb-text-title)' }}>
                총 지급액
              </span>
              <span style={{ 
                fontWeight: 700, 
                color: 'var(--mb-color-primary)',
                fontSize: 16
              }}>
                {settlementInfo.totalAmount.toLocaleString()} pt
              </span>
            </div>
          </div>
        )}

        {/* 경고 문구 */}
        <div style={{
          padding: '12px 16px',
          background: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: 8,
          marginBottom: 24,
          fontSize: 13,
          color: '#856404',
          lineHeight: 1.5,
          fontWeight: 500
        }}>
          ⚠️ 정산 완료 후에는 <strong>수정이 불가능</strong>합니다.
        </div>

        {/* 버튼 */}
        <div className="mbm-foot">
          <button 
            onClick={onClose} 
            className="mb-btn mb-btn-secondary"
            style={{ 
              flex: 1,
              padding: '12px 20px',
              fontSize: 15,
              fontWeight: 600
            }}
          >
            취소
          </button>
          <button 
            onClick={onConfirm} 
            className="mb-btn mb-btn-primary"
            style={{ 
              flex: 1,
              padding: '12px 20px',
              fontSize: 15,
              fontWeight: 600
            }}
          >
            정산 진행
          </button>
        </div>
      </div>
    </div>
  );
}

export default SettleConfirmModal;

